import React from 'react'
import { Translate } from 'i18n'
import './style.css'


export default () => (
    <div className='items-empty-list'>
        <Translate value='noItemsAdded' />
    </div>
)
